export default "__VITE_ASSET__FgVzeZWZ__"